export default __webpack_public_path__ + "static/media/Penguin.758a8f47.svg";